// @flow

import api from "api";
import { all } from "axios";
import type { SearchParams, ExportParams } from "types/Global";

export const fetchAll = (url: string, params: SearchParams) => {
  return all([fetchPaginatedData(url, params), fetchCount(url, params)]);
};

export const fetchPaginatedData = (url: string, params: SearchParams) => {
  return api.get(url, { params });
};

export const fetchCount = (url: string, params: SearchParams) => {
  return api.get(url + "/count", { params });
};

export const fetchUnpaginatedData = (url: string) => {
  return api.get(url);
};

export const getExport = (url: string, params: ExportParams = {}) => {
  return api.get(url, { params });
};
